import {useEffect, useState} from "react";
import axios from "axios";

import config from '../config.json';

const useCheckPanelAdministrator = () => {
    const [isLoading, setLoading] = useState(false);
    const [panelAdministrator, setPanelAdministrator] = useState(null);

    useEffect(() => {
        axios({
            url: `${config.backendUrl}/maps/panelAdministrator`,
            withCredentials: true,
            method: 'get'
        })
            .then(response => { setPanelAdministrator(response.data.panelAdministrator); setLoading(false); })
            .catch(error => console.log(error));
    });

    return { isLoading, panelAdministrator };
}

export default useCheckPanelAdministrator;
